import {Post} from './post';
import {UserDto} from '../../user/data/userDto';

export class PostDto {
  parent: PostDto | undefined;
  author: UserDto;
  post: Post;
  tags: string[];
  categories: number[];
}

